module.exports = __webpack_public_path__ + "static/img/pc-video-mark.3e653ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/pc-video-mark.png
// module id = 9bvs
// module chunks = 0